<div class="info">
  <div class="headline-actions">
    <h4 class="headline">
      {{ translationPath + 'infoHeader' | transloco }}
    </h4>
  </div>

  <p>
    {{ translationPath + 'infoText' | transloco }}
    @if (showInfoNotice) {
      <br />
      <span>
        <b>
          {{ translationPath + 'infoNotice' | transloco }}
        </b></span
      >
      <span>
        {{ translationPath + 'infoNoticeText' | transloco }}
      </span>
    }
  </p>
</div>
